import { render, staticRenderFns } from "./assess-mid-year-details.vue?vue&type=template&id=037f842c&"
import script from "./assess-mid-year-details.vue?vue&type=script&lang=js&"
export * from "./assess-mid-year-details.vue?vue&type=script&lang=js&"
import style0 from "./assess-mid-year-details.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports